
import { Component, Vue } from "vue-property-decorator";
import { startDiagnostics, getStoreTongueExpireCountAndNumberOld as getStoreTongueExpireCountAndNumberApi } from "@/api/open";

import UploadImg from "@/components/uploadImg.vue";

import { getCatchByKey } from "@/utils/catch";
import { EnumerateEnum } from "@/enum/enum.enum";

import { md5 } from "js-md5";
import dayjs from "dayjs";

@Component({ name: 'open-tongue-components-collectStep1',
    components: {
        UploadImg
    }
})
export default class OpenTongueCollectStep1 extends Vue {

    frontImageUrl = [];
    backImageUrl = [];

    btnLoading = false;

    useOut = false;

    deviceCode = this.$route.query.deviceCode as string;
  // 后面你可以在这里加：
  // frontFile: File | null = null
  // backFile: File | null = null

  mounted() {
    this.getStoreTongueExpireCountAndNumber();
  }

  startDiagnosticsAction() {
    const curDate = new Date();
    const dataKey = dayjs(curDate).format("YYYY-MM-DD HH:mm:ss");
    const deviceId = getCatchByKey(EnumerateEnum.openTongueDeviceId);
    const qrCodeUid = getCatchByKey(EnumerateEnum.openTongueQrCodeUid);
    const mdKey = md5(deviceId + dataKey);
    this.btnLoading = true;
      startDiagnostics({
        deviceId: deviceId,
        qrCodeUid: qrCodeUid,
        tongueFrontImgPath: this.frontImageUrl?.[0]?.url || "",
        tongueBottomImgPath: this.backImageUrl?.[0]?.url || "",
        currentTime: dataKey,
        headers: {
          sign: mdKey
        }
      }).then((res) => {
        console.log(res);
        this.$emit("goCheckResult", res.data);
      }).catch((err) => {
        this.$message.error("上传失败");
        console.error(err);
      }).finally(() => {
        this.btnLoading = false;
      });
  }

  getStoreTongueExpireCountAndNumber() {
    if (!this.deviceCode) return;
    const params = {
      deviceCode: this.deviceCode,
      typeId: "10001"
    };
    getStoreTongueExpireCountAndNumberApi(params).then(res => {
      const { expireDays, remainDiagnosesNumber } = res.data;
      const deCount = remainDiagnosesNumber ?? 0;
      const expireCount = expireDays ?? 0;
      if (expireCount <= 0 || deCount == 0) {
        this.useOut = true;
      }
    });
  };
}
